// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2zJim","checkboxCol":"Table_checkboxCol__286vF","emailCol":"Table_emailCol__kkhoI","actionCol":"Table_actionCol__3inpp"};